import { observer } from 'mobx-react-lite'
import { Breadcrumbs, ContainerHeader, FullPageWrapper } from 'shared/ui'
import { HubspotWorkflowsPath } from 'entities/ExportRouters'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { HubspotWorkflowStatisticsFilter } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/ui/HubspotWorkflowStatisticsFilter'
import { HubspotWorkflowStatisticsTable } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/ui/HubspotWorkflowStatisticsTable'
import { HubspotWorkflowStatisticsSearch } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/ui/HubspotWorkflowStatisticsSearch'
import styles from './styles.module.scss'
import { useHubspotWorkflowViewContext } from './context/context'

export const HubspotWorkflowView = observer(() => {
  const { contactsDetailsStore, workflow, pageLayoutStore } = useHubspotWorkflowViewContext()
  const { titleIconProps, headerMenuIconAction, headerMenuTooltipIconProps } = pageLayoutStore

  return (
    <FullPageWrapper>
      <Breadcrumbs
        customPath={`/${HubspotWorkflowsPath.root}`}
        getLabel={() => 'Hubspot workflows'}
      />
      <ContainerHeader
        title={workflow?.name}
        titleVariant={'heading-md'}
        titleIconProps={titleIconProps}
        titleIconAction={headerMenuIconAction}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        ellipsis
        className={styles.containerHeader}
      />
      <HubspotWorkflowStatisticsFilter />
      <HubspotWorkflowStatisticsSearch />
      <HubspotWorkflowStatisticsTable />
      {contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
    </FullPageWrapper>
  )
})
